import React from "react";
import Combobox from "./Combobox";
import {
  CONDICIONES_PAGO_OPTS,
  TIEMPO_ENTREGA_OPTS,
} from "./cotizacionConstants";

export default function TerminosSection({
  condicionesPago,
  setCondicionesPago,
  tiempoEntrega,
  setTiempoEntrega,
  notas,
  setNotas,
  markDirty,
  cpOpen,
  setCpOpen,
  teOpen,
  setTeOpen,
  cpAnchorRef,
  cpPanelRef,
  cpPos,
  teAnchorRef,
  tePanelRef,
  tePos,
  invalidFields = {},
}) {
  return (
    <div className="cf-grid cf-grid-2">
      <Combobox
        inputClassName={invalidFields?.condicionesPago ? "cf-invalid" : ""}
        label="Condiciones de Pago"
        required
        placeholder="Seleccionar o escribir personalizado"
        value={condicionesPago || ""}
        onChange={(v) => {
          setCondicionesPago?.(v);
          markDirty?.();
        }}
        open={cpOpen}
        setOpen={setCpOpen}
        anchorRef={cpAnchorRef}
        panelRef={cpPanelRef}
        pos={cpPos}
        items={CONDICIONES_PAGO_OPTS}
        ariaLabel="Condiciones de pago"
        helpText="Ej: 50% anticipo, 50% contra entrega"
        filterFn={(opt) =>
          opt.toLowerCase().includes((condicionesPago || "").toLowerCase())
        }
        getKey={(opt) => opt}
        renderItem={(opt) => <div className="cf-combobox-item-text">{opt}</div>}
        onSelect={(opt) => {
          setCondicionesPago?.(opt);
          setCpOpen(false);
          markDirty?.();
        }}
      />

      <Combobox
        label="Tiempo de Entrega"
        placeholder="Seleccionar o escribir personalizado"
        value={tiempoEntrega || ""}
        onChange={(v) => {
          setTiempoEntrega?.(v);
          markDirty?.();
        }}
        open={teOpen}
        setOpen={setTeOpen}
        anchorRef={teAnchorRef}
        panelRef={tePanelRef}
        pos={tePos}
        items={TIEMPO_ENTREGA_OPTS}
        ariaLabel="Tiempo de entrega"
        helpText="Ej: 7 días hábiles"
        filterFn={(opt) =>
          opt.toLowerCase().includes((tiempoEntrega || "").toLowerCase())
        }
        getKey={(opt) => opt}
        renderItem={(opt) => <div className="cf-combobox-item-text">{opt}</div>}
        onSelect={(opt) => {
          setTiempoEntrega?.(opt);
          setTeOpen(false);
          markDirty?.();
        }}
      />

      <div className="cf-field cf-col-span-2">
        <label className="cf-label">Notas Adicionales</label>
        <textarea
          className="cf-textarea"
          value={notas || ""}
          onChange={(e) => {
            setNotas?.(e.target.value);
            markDirty?.();
          }}
          placeholder="Términos y condiciones, garantías, etc."
        />
      </div>
    </div>
  );
}
